module.exports = __webpack_public_path__ + "static/media/GRASIM.1bdc4fa3.txt";